import { inject, Observer } from "mobx-react"
import { WithRouterProps } from "next/dist/client/with-router"
import Head from "next/head"
import { withRouter } from "next/router"
import React from "react"
import styled, { css } from "styled-components"

import CtaLink from "~/components/atoms/CtaLink"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import { ContainerLarge } from "~/components/layouts/Container"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import { Color, IsMobile, LineHeight, RadiusSize, SpacingSize, TextSize, Z } from "~/consts/style-mixins"
import TabBar from "~/observers/TabBar"
import { staticPath } from "~/services/helper"
import ProfileStore from "~/stores/ProfileStore"
import UserStore from "~/stores/UserStore"

interface Props {
  userStore: UserStore
  profileStore: ProfileStore
}

@inject("userStore", "profileStore")
class NewGradsProfileCampaign2021 extends React.Component<WithRouterProps & Props> {
  render() {
    const { userStore, profileStore } = this.props

    return (
      <>
        <Head>
          <title>【23卒限定】プロフィール入力キャンペーン | Infra 新卒（インフラ新卒）</title>
          <meta
            name="description"
            content="プロフィールを入力してAmazonギフト券3,000円が必ず貰えるキャンペーンに参加しよう！プロフィールを充実させて企業からのスカウト受信数が多かった上位10名にはさらに10,000円分をプレゼント！"
          />
          <meta name="og:title" content="【23卒限定】プロフィール入力キャンペーン | Infra 新卒（インフラ新卒）" />
          <meta
            name="og:description"
            content="プロフィールを入力してAmazonギフト券3,000円が必ず貰えるキャンペーンに参加しよう！プロフィールを充実させて企業からのスカウト受信数が多かった上位10名にはさらに10,000円分をプレゼント！"
          />
          <meta
            name="og:image"
            content={process.env.APP_HOST + staticPath("/static/images/new-grads-profile-campaign-2021-ogp.png")}
          />
        </Head>
        <Container>
          <Header showTab logoType="NewGradJobs" />
          {/* <EndAnnounce>
            <div className="end-announce_inner heading">キャンペーンは終了しました</div>
          </EndAnnounce> */}
          <RenewalAnnounce>
            <div className="inner renewal-announce">
              <p className="sub-heading">＼ 希望職種の本選考スカウトが届く ／</p>
              <p className="label">2023卒限定企画</p>
              <h1 className="main-heading">
                <Pc>
                  プロフィールを入力して
                  <br />
                  Amazonギフト券3,000円が必ず貰える
                  <br />
                  キャンペーンに参加しよう
                </Pc>
                <Sp>
                  プロフィールを入力して
                  <br />
                  Amazonギフト券3,000円が
                  <br />
                  必ず貰えるキャンペーン
                </Sp>
              </h1>
            </div>
          </RenewalAnnounce>
          <CampaignSummury>
            <div className="inner">
              <p className="ribon">
                <span className="ribon-inner">2023卒限定キャンペーン</span>
              </p>
              <div className="benefit-wrapper">
                <div className="benefit-each-container">
                  <p className="benefit-following-text">
                    {!userStore.authed && "登録後に"}プロフィール入力が完了すると
                  </p>
                  <div className="benefit">
                    <p className="benefit-condition">12/8(水)までの応募で必ず貰える</p>
                    <p className="benefit-present">
                      <span className="benefit-present-inner">
                        <span>
                          Amazon
                          <br />
                          ギフト
                        </span>
                        <span className="attention">3,000</span>
                        <span>
                          円分
                          <br />
                          プレゼント
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="benefit-plus-icon">＋</div>
                <div className="benefit-each-container">
                  <p className="benefit-following-text">12月末までに企業から受け取った</p>
                  <div className="benefit">
                    <p className="benefit-condition">本選考スカウト受信数 上位10名に</p>
                    <p className="benefit-present">
                      <span className="benefit-present-inner">
                        <span>さらに</span>
                        <span className="attention">10,000</span>
                        <span>
                          円分
                          <br />
                          プレゼント
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <ActionButton userStore={userStore} profileStore={profileStore} />
            </div>
          </CampaignSummury>
          {/* <CallApply>
            <div className="inner call-apply_container">
              <div className="call-apply_appeal">
                <div className="call-apply_label">入力が面倒な方へ</div>
                <p className="call-apply_heading">
                  電話で大学時代の経験を自慢して、
                  <br className="pc-hide" />
                  キャンペーンに参加しよう！
                </p>
                <p className="call-apply_supplement">
                  キャリアアドバイザーが経験をまとめて入力代行します。
                  <br className="pc-hide" />
                  そのままESにも使えるのでオススメ。
                  <br />
                  もちろん、Amazonギフトもプレゼントします！
                </p>
              </div>
              <div className="call-apply_action">
                <Observer>
                  {() => (
                    <a
                      className={
                        userStore.authed
                          ? userStore.user && userStore.user.newGradsCampaign
                            ? "call-apply_action-button gtm_new-grads-campaign-call-apply disabled"
                            : "call-apply_action-button gtm_new-grads-campaign-call-apply"
                          : "call-apply_action-button gtm_new-grads-campaign-call-apply"
                      }
                      href="https://forms.gle/Nzko5QCF48zShbPUA"
                      target="_blank"
                    >
                      {userStore.authed ? (
                        userStore.user && userStore.user.newGradsCampaign ? (
                          <>キャンペーン申込済み</>
                        ) : (
                          <>申し込む</>
                        )
                      ) : (
                        <>申し込む</>
                      )}
                    </a>
                  )}
                </Observer>
                <p className="call-apply_action-supplement">
                  ご希望の方は名前と電話番号を入力し申し込みください
                  <br />
                  こちらからお電話差し上げます
                </p>
              </div>
            </div>
          </CallApply> */}
          <CampaignDetail>
            <div className="inner">
              <h2 className="heading">キャンペーン概要</h2>
              <div className="flow-wrapper">
                <div className="flow-each-container">
                  <div className="flow-each-number">1</div>
                  <p className="flow-text">
                    会員登録して
                    <br />
                    プロフィールの
                    <br />
                    必須項目を
                    <br />
                    埋める
                  </p>
                </div>
                <div className="flow-icon">
                  <Pc>▶</Pc>
                  <Sp>▼</Sp>
                </div>
                <div className="flow-each-container">
                  <div className="flow-each-number">2</div>
                  <p className="flow-text">
                    12/8(水)までの応募で
                    <br />
                    3,000円分の
                    <br />
                    Amazonギフト券を
                    <br />
                    必ずプレゼント
                  </p>
                </div>
                <div className="flow-icon">＋</div>
                <div className="flow-each-container">
                  <div className="flow-each-number">3</div>
                  <p className="flow-text">
                    12月末までの
                    <br />
                    本選考スカウト数
                    <br />
                    上位10名に
                    <br />
                    さらに1万円
                  </p>
                </div>
              </div>
              {/* <div className="screening-container">
                <div className="screening-heading">審査ポイント</div>
                <div className="screening-content">
                  <div className="screening-content-left">
                    <div className="screening-text-wrapper">
                      <div className="screening-label">目標</div>
                      <p className="screening-text">目標設定の背景と掲げた目標の大きさ</p>
                    </div>
                    <div className="screening-text-wrapper">
                      <div className="screening-label">成果</div>
                      <p className="screening-text">️定量的かつ大きな実績が残せているか</p>
                    </div>
                    <div className="screening-text-wrapper">
                      <div className="screening-label">主体性</div>
                      <p className="screening-text">️自分で考えて行動ができているか</p>
                    </div>
                  </div>
                  <div className="screening-content-right">
                    <div className="screening-text-wrapper">
                      <div className="screening-label">論理性</div>
                      <p className="screening-text">論理的に考えて行動ができているか</p>
                    </div>
                    <div className="screening-text-wrapper">
                      <div className="screening-label">文章構成</div>
                      <p className="screening-text">経験や成果が分かりやすく伝わる文章か</p>
                    </div>
                  </div>
                </div>
              </div>
              <ActionButton userStore={userStore} profileStore={profileStore} /> */}
            </div>
          </CampaignDetail>
          <ServiceFeature>
            <div className="inner">
              <h2 className="heading">Infra 新卒のメリット</h2>
              <div className="feature">
                <div className="each-feature">
                  <img src={staticPath("/static/images/new-grad-job/feature/resume.svg")} />
                  <div className="feature-text">
                    <p className="feature-text-heading">
                      希望職種で求人が探せる
                      <br />
                      ＆スカウトが届く
                    </p>
                  </div>
                </div>
                <div className="each-feature">
                  <img src={staticPath("/static/images/new-grad-job/feature/job.svg")} />
                  <div className="feature-text">
                    <p className="feature-text-heading">
                      あなたの経験を見て、
                      <br />
                      あなただけの
                      <br />
                      スカウトが届く
                    </p>
                  </div>
                </div>
                <div className="each-feature">
                  <img src={staticPath("/static/images/new-grad-job/feature/evaluation.svg")} />
                  <div className="feature-text">
                    <p className="feature-text-heading">
                      学生時代の経験が
                      <br />
                      評価される
                    </p>
                  </div>
                </div>
              </div>
              <ActionButton userStore={userStore} profileStore={profileStore} />
            </div>
          </ServiceFeature>
          <Caution>
            <div className="inner">
              <h2 className="heading">注意事項</h2>
              <ul className="content">
                <li>本キャンペーンはInfraを運営する株式会社Legaseedによる提供です。</li>
                <li>本キャンペーンは2023年3月卒業見込みの学生を対象としたキャンペーンです。</li>
                <li>当選された方には、ご登録いただいたメールアドレス宛にAmazonギフト券を送付いたします。</li>
                <li>応募からAmazonギフト券の発送までに最大2ヶ月程度かかる場合がございます。</li>
                <li>
                  スカウト受信数の集計期間はキャンペーン応募後から2021年12月31日までとします。また集計対象は本選考に関するスカウトのみとし、インターンやイベントに関するスカウトは対象外となります。
                </li>
                <li>
                  当社の基準に従い、ご入力いただいたプロフィール情報が適切ではないと判断した場合、当該応募を無効とする場合があります。その場合当社からご連絡することはいたしません。あらかじめご了承ください。
                </li>
                <li>
                  同一人物が複数回答したと当社が判断した際は、応募を無効とする場合があります。その場合当社からご連絡することはいたしません。あらかじめご了承ください。
                </li>
              </ul>
            </div>
          </Caution>
          {/* <ListedCompany>
            <div className="inner">
              <p className="heading">過去のInfra掲載企業</p>
              <ul className="logo-list">
                <li>
                  <img src={staticPath("/static/images/new-grad-job/listed-company/logo_1.png")} className="logo-img" />
                </li>
                <li>
                  <img src={staticPath("/static/images/new-grad-job/listed-company/logo_2.png")} className="logo-img" />
                </li>
                <li>
                  <img src={staticPath("/static/images/new-grad-job/listed-company/logo_3.png")} className="logo-img" />
                </li>
                <li>
                  <img src={staticPath("/static/images/new-grad-job/listed-company/logo_4.png")} className="logo-img" />
                </li>
                <li>
                  <img src={staticPath("/static/images/new-grad-job/listed-company/logo_5.png")} className="logo-img" />
                </li>
                <li>
                  <img src={staticPath("/static/images/new-grad-job/listed-company/logo_6.png")} className="logo-img" />
                </li>
                <li>
                  <img src={staticPath("/static/images/new-grad-job/listed-company/logo_7.png")} className="logo-img" />
                </li>
                <li>
                  <img src={staticPath("/static/images/new-grad-job/listed-company/logo_8.png")} className="logo-img" />
                </li>
              </ul>
            </div>
          </ListedCompany> */}
          <Sp>
            <TabBar selectedTabIndex={0} />
          </Sp>
        </Container>
        <Footer />
      </>
    )
  }
}

const ActionButton = ({ userStore, profileStore }: Props) => {
  return (
    <Observer>
      {() => (
        <StyledActionButton>
          <p className="apply-step_push">
            <span className="apply-step_push-inner">＼ プロフィール充実でスカウトが届く！ ／</span>
          </p>
          <CtaLink size="Medium" href="" className="button" disabled>
            キャンペーンは終了しました
          </CtaLink>
          {/* <CtaLink
            size="Medium"
            href={
              userStore.authed
                ? internalLink("/profile?access_from=new-grads-profile-campaign-2021-lp")
                : internalLink("/auth/register?code=profile_campaign_2021")
            }
            className={`button ${
              userStore.authed
                ? "gtm_new-grads-profile-campaign-2021-profile-link-on-lp"
                : "gtm_new-grads-profile-campaign-2021-register-link-on-lp"
            }`}
            disabled={profileStore.isAppliedToCampaign}
          >
            {userStore.authed ? (
              profileStore.isAppliedToCampaign ? (
                <>キャンペーン応募済み</>
              ) : (
                <>プロフィールを入力する</>
              )
            ) : (
              <>会員登録フォームへ</>
            )}
          </CtaLink>
          {!userStore.authed && (
            <TransitionLink
              size="Medium"
              href={`${process.env.INFRA_INTERN_URL}/auth/login`}
              isButton
              className="button login-button"
            >
              登録済みの方はこちらからログイン
            </TransitionLink>
          )} */}
          <p className="deadline">申込締切：12月8日(水)</p>
        </StyledActionButton>
      )}
    </Observer>
  )
}

const Container = styled.div`
  overflow: hidden;
  .inner {
    padding: 48px 0;
    ${IsMobile(css`
      padding: 32px 0;
    `)}
  }
  .button {
    max-width: 320px;
    width: 100%;
    margin: ${SpacingSize.XL}px auto 0;
  }
  .heading {
    margin-bottom: ${SpacingSize.XL}px;
    font-size: ${SpacingSize.XL}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    text-align: center;
    ${IsMobile(css`
      font-size: 20px;
    `)}
  }
  .pc-hide {
    display: none;
    ${IsMobile(css`
      display: block;
    `)}
  }
  .sp-hide {
    ${IsMobile(css`
      display: none;
    `)}
  }
  .login-button {
    margin-top: 12px;
  }
`
const EndAnnounce = styled(ContainerLarge)`
  background: ${Color.BorderGray};
  .end-announce_inner {
    padding: 24px 0;
  }
`

const RenewalAnnounce = styled(ContainerLarge)`
  position: relative;
  background: ${Color.Attention};
  text-align: center;
  &::after {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    background: ${Color.Attention};
    bottom: -10px;
    left: calc(50% - 10px);
    transform: rotate(45deg);
    z-index: 3;
  }
  .label {
    display: inline-block;
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.S}%;
    font-weight: bold;
    color: ${Color.Attention};
    background: ${Color.White};
    margin: auto;
    padding: ${SpacingSize["3XS"]}px ${SpacingSize.S}px;
    border-radius: ${RadiusSize.Medium}px;
    ${IsMobile(css`
      font-size: 14px;
    `)}
  }
  .sub-heading {
    margin-bottom: ${SpacingSize.S}px;
    color: ${Color.White};
    font-size: 14px;
    font-weight: bold;
  }
  .main-heading {
    margin-top: ${SpacingSize.S}px;
    font-size: 28px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    color: ${Color.White};
    ${IsMobile(css`
      font-size: 24px;
    `)}
  }
`

const CampaignSummury = styled(ContainerLarge)`
  background: ${Color.BackgroundGray};
  text-align: center;
  .ribon {
    position: relative;
    background: #f2c41f;
    color: ${Color.White};
    font-size: ${TextSize.M}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    padding: ${SpacingSize["2XS"]}px 0;
    max-width: 360px;
    width: 100%;
    text-align: center;
    margin: auto;
    ${IsMobile(css`
      max-width: 300px;
      font-size: 14px;
    `)}
    &::before {
      position: absolute;
      content: "";
      border-width: 22px 11px;
      border-color: transparent ${Color.BackgroundGray} transparent transparent;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      ${IsMobile(css`
        border-width: 18px 9px;
      `)}
    }
    &::after {
      position: absolute;
      content: "";
      border-width: 22px 11px;
      border-color: transparent transparent transparent ${Color.BackgroundGray};
      top: 0;
      left: 0;
      width: 0;
      height: 0;
      border-style: solid;
      ${IsMobile(css`
        border-width: 18px 9px;
      `)}
    }
  }
  .ribon-inner {
    display: block;
    padding: 6px 0;
    border-top: solid 1px ${Color.White};
    border-bottom: solid 1px ${Color.White};
    ${IsMobile(css`
      padding: 4px 0;
    `)}
  }
  .benefit-wrapper {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${IsMobile(css`
      flex-direction: column;
    `)}
  }
  .benefit-plus-icon {
    margin: 48px 10px 0;
    font-size: 40px;
    color: ${Color.Primary};
    ${IsMobile(css`
      margin-top: 8px;
    `)}
  }
  .benefit-following-text {
    font-size: ${TextSize.S}px;
    font-weight: bold;
    color: ${Color.Black};
    line-height: ${LineHeight.M}%;
    margin-top: ${SpacingSize.XS}px;
  }
  .benefit {
    border: 2px ${Color.Primary} solid;
    max-width: 320px;
    width: 100%;
    margin: ${SpacingSize.M}px auto auto;
  }
  .benefit-condition {
    font-size: ${TextSize.M}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    color: ${Color.White};
    background: ${Color.Primary};
    padding: ${SpacingSize["3XS"]}px 0;
  }
  .benefit-present {
    font-size: ${TextSize.S}px;
    font-weight: bold;
    line-height: 120%;
    color: ${Color.Black};
    text-align: center;
    padding: ${SpacingSize.S}px ${SpacingSize.XL}px;
  }
  .benefit-present-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    .attention {
      font-size: ${TextSize["4XL"]}px;
      font-weight: bold;
      color: ${Color.Attention};
      padding: 0 ${SpacingSize["3XS"]}px;
    }
  }
  .apply-step {
    margin-top: ${SpacingSize.M}px;
  }
  .apply-step_heading {
    font-weight: bold;
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.S}%;
  }
  .apply-step_flow {
    display: flex;
    justify-content: space-between;
    max-width: 640px;
    margin: ${SpacingSize.M}px auto 0;
    li {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 48px;
      width: calc(33.3% - 2px);
      color: ${Color.White};
      background: ${Color.Secondary};
      font-weight: bold;
      font-size: ${TextSize.XS}px;
      line-height: ${LineHeight.S}%;
      ${IsMobile(css`
        height: 64px;
      `)}
      .apply-step_flow-text {
        margin-left: 8px;
      }
      &:not(:first-child) {
        &:before {
          position: absolute;
          content: "";
          border-width: 24px 12px;
          border-color: transparent transparent transparent #f7f7f7;
          top: 0;
          left: 0;
          width: 0;
          height: 0;
          border-style: solid;
          ${IsMobile(css`
            border-width: 32px 16px;
          `)}
        }
      }
      &:not(:last-child) {
        &:after {
          position: absolute;
          content: "";
          border-width: 24px 12px;
          border-color: transparent transparent transparent ${Color.Secondary};
          top: 0;
          right: -24px;
          width: 0;
          height: 0;
          border-style: solid;
          z-index: ${Z.Child};
          ${IsMobile(css`
            border-width: 32px 16px;
            right: -32px;
          `)}
        }
      }
    }
  }
`
const CallApply = styled(ContainerLarge)`
  background: #009688;
  color: #fff;
  .call-apply_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${IsMobile(css`
      flex-direction: column;
      text-align: center;
    `)}
  }
  .call-apply_appeal {
  }
  .call-apply_heading {
    font-weight: bold;
    font-size: 20px;
    line-height: 140%;
    margin-top: 4px;
  }
  .call-apply_label {
    font-weight: bold;
    font-size: 16px;
    line-height: 140%;
  }
  .call-apply_supplement {
    font-size: 12px;
    line-height: 140%;
    margin-top: 4px;
  }
  .call-apply_action-button {
    display: block;
    max-width: 320px;
    width: 100%;
    background: #fff;
    text-align: center;
    color: #009688;
    font-size: 16px;
    font-weight: bold;
    padding: 16px;
    border-radius: 24px;
    ${IsMobile(css`
      margin-top: 16px;
    `)}
    &.disabled {
      pointer-events: none;
      opacity: 0.8;
    }
  }
  .call-apply_action-supplement {
    font-size: 12px;
    line-height: 140%;
    text-align: center;
    margin-top: 8px;
  }
`
const CampaignDetail = styled(ContainerLarge)`
  .flow-wrapper {
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${IsMobile(css`
      flex-direction: column;
    `)}
  }
  .flow-each-container {
    position: relative;
    width: 184px;
    height: 184px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${Color.BackgroundPrimary};
    border-radius: 50%;
  }
  .flow-each-number {
    position: absolute;
    top: 15px;
    width: 30px;
    height: 30px;
    font-weight: bold;
    text-align: center;
    line-height: 30px;
    color: ${Color.White};
    background-color: ${Color.Primary};
    border-radius: 50%;
  }
  .flow-text {
    margin-top: 12px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    color: ${Color.Primary};
  }
  .flow-icon {
    margin: 0 24px;
    color: ${Color.Primary};
    font-size: 40px;
    ${IsMobile(css`
      margin: 14px 0;
    `)}
  }

  .screening-heading {
    margin-bottom: 20px;
    padding: 8px 12px;
    text-align: center;
    font-size: ${TextSize.S}px;
    font-weight: bold;
    color: ${Color.Primary};
    background-color: ${Color.BackgroundGray};
    border-radius: 8px;
  }
  .screening-content {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    ${IsMobile(css`
      flex-direction: column;
    `)}
  }
  .screening-content-left {
    margin: 0 48px 0 12px;
    ${IsMobile(css`
      margin: 0;
    `)}
  }
  .screening-text-wrapper {
    margin-bottom: 4px;
    display: flex;
  }
  .screening-label {
    width: 66px;
    margin-right: 12px;
    padding: 3px 8px;
    display: inline-block;
    text-align: center;
    font-size: ${TextSize.XS}px;
    font-weight: bold;
    color: ${Color.Primary};
    background-color: ${Color.BackgroundPrimary};
    border: 1px solid ${Color.Primary};
    border-radius: 8px;
  }
  .screening-text {
    font-size: ${TextSize.S}px;
    line-height: 20px;
  }
`

const ServiceFeature = styled(ContainerLarge)`
  .feature {
    display: flex;
    justify-content: space-around;
    ${IsMobile(css`
      flex-direction: column;
    `)}
  }
  .each-feature {
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .feature-text {
    margin-left: ${SpacingSize.M}px;
  }
  .feature-text-heading {
    width: 160px;
    font-size: ${TextSize.S}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
  }
  .feature-text-supplement {
    font-size: ${TextSize.XS}px;
    color: ${Color.Gray};
    margin-top: ${SpacingSize.XS}px;
    line-height: ${LineHeight.S}%;
  }
`
const Caution = styled(ContainerLarge)`
  background: ${Color.BackgroundGray};
  .content {
    list-style: decimal;
    font-size: ${TextSize.XS}px;
    line-height: ${LineHeight.M}%;
    color: ${Color.Gray};
    ${IsMobile(css`
      margin-left: 12px;
    `)}
  }
`

const ListedCompany = styled(ContainerLarge)`
  background: ${Color.BackgroundGray};
  .logo-list {
    display: flex;
    margin-top: ${SpacingSize.XL}px;
    ${IsMobile(css`
      flex-wrap: wrap;
      margin-top: 0;
    `)}
    li {
      width: 12.5%;
      height: auto;
      ${IsMobile(css`
        margin-top: 24px;
        width: calc(50% - 12px);
      `)}
      &:not(:first-child) {
        margin-left: ${SpacingSize["2XL"]}px;
        ${IsMobile(css`
          margin-left: 0;
        `)}
      }
      &:nth-child(even) {
        ${IsMobile(css`
          margin-left: 24px;
        `)}
      }
    }
  }
  .logo-img {
    width: 100%;
  }
`

const StyledActionButton = styled.div`
  text-align: center;
  .apply-step_push {
    color: ${Color.Black};
    font-weight: bold;
    font-size: ${TextSize.S}px;
    line-height: ${LineHeight.S}%;
    margin-top: ${SpacingSize["2XL"]}px;
    margin-bottom: -16px;
  }
  .apply-step_push-inner {
    position: relative;
    color: ${Color.Attention};
  }
  .deadline {
    font-weight: bold;
    font-size: ${TextSize.S}px;
    line-height: ${LineHeight.S}%;
    margin-top: ${SpacingSize.XS}px;
  }
  .note {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    margin-top: ${SpacingSize.M}px;
    li {
      font-size: ${TextSize.XS}px;
      line-height: ${LineHeight.S}%;
      color: ${Color.Gray};
      text-align: left;
      text-indent: -1em;
      padding-left: 1em;
      &:not(:first-child) {
        margin-top: ${SpacingSize["3XS"]}px;
      }
    }
  }
`

export default withRouter(NewGradsProfileCampaign2021)
